import React from "react";
import "./CulturalProgram.css";
import Navbar from "./Navbar";
import Footer from "./Footer";




    // Replace these image paths with your actual image URLs / imports
    

    const CulturalProgram = () => {
        const images = [
            "/stis2025/assets/cu1.jpeg",
            "/stis2025/assets/cu2.jpeg",
            "/stis2025/assets/cu3.jpeg",
            "/stis2025/assets/cu4.jpeg",
            "/stis2025/assets/cu5.jpeg",
            "/stis2025/assets/cu6.jpeg",
    
        ];
        return (
          <>
            <Navbar />
            <div className="cultural-page">
              <header className="cultural-hero">
                <div className="cultural-overlay" />
                <div className="cultural-hero-content">
                  <p className="cultural-tagline">J.N. Tata Auditorium, IISc Bengaluru, 10th December 2025, 6:15 PM onwards</p>
                  <h1 className="cultural-title"> Cultural Program by Kalaanidhi Nruthya Mandiram</h1>
                  <p className="cultural-subtitle">
                    A vibrant showcase of classical dance, music, traditions, and flavours of
                     India.
                  </p>
                </div>
              </header>
      
              {/* Top image strip */}
              <section className="cultural-image-strip">
                {images.map((src, index) => (
                  <div className="cultural-image-wrapper" key={index}>
                    <img src={src} alt={`Cultural glimpse ${index + 1}`} />
                  </div>
                ))}
              </section>
      
              {/* Main content / write-up */}
              <main className="cultural-content">
                <section className="cultural-section" style={{textAlign: "justify", marginBottom:"30px"}}>
                  <h2>About the Performance</h2>
      
                  <p>
                    <strong>Kalaanidhi Nruthya Mandiram</strong>, led by <strong>Vidushi Sneha Devanandan</strong>, 
                    presents a vibrant showcase of Bharathanatyam classical dance. As an empanelled artist of 
                    <strong> ICCR</strong> and an "<strong>A</strong>" grade Doordarshan performer, Sneha Devanandan 
                    has presented Bharathanatyam across countries including the <strong>USA, Canada, Sri Lanka, 
                    Australia, Kenya, China, France, Mauritius</strong>, and the Middle East.
                  </p>
      
                  <p>
                    The troupe presents productions that capture the essence of Indian culture through classical 
                    dance, blending traditional repertoire with evocative choreography and music. The performances 
                    combine innovation with spiritual depth, allowing audiences to experience the richness of this 
                    ancient art form. The music blends traditional and contemporary instruments, creating a unique 
                    soundscape that enhances the visual storytelling.
                  </p>
                </section>

                <section className="cultural-section">
                  <h2>Performance Sequence</h2>
                  <div className="dance-cards-grid">
                    <div className="dance-card">
                      <h3>Ganesha Talam</h3>
                      <p>
                        A rhythmically complex composition celebrating the divine energies of Lord Ganesha, 
                        depicting festive vibrance, auspicious beginnings, and the balance of strength and grace.
                      </p>
                    </div>

                    <div className="dance-card">
                      <h3>The Divine Shakti – Raja Rajeshwari</h3>
                      <p>
                        Portrays the triumph of the goddess over Bandasura, symbolising the victory of good over evil, 
                        followed by an invocation to Maha Lakshmi to invoke prosperity and positive energy.
                      </p>
                    </div>

                    <div className="dance-card">
                      <h3>Charana Shringa Sloka of Nataraja</h3>
                      <p>
                        A powerful presentation showcasing intricate <em>karanas</em> and postures that reflect 
                        the cosmic dance of creation, preservation, and dissolution.
                      </p>
                    </div>

                    <div className="dance-card">
                      <h3>Krishna Leela</h3>
                      <p>
                        A sequence depicting the enchanting world of Krishna, portraying his playful leelas, 
                        from mischievous childhood pranks to the dramatic subduing of Kalinga.
                      </p>
                    </div>

                    <div className="dance-card">
                      <h3>Thillana</h3>
                      <p>
                        A vibrant conclusion featuring a dynamic jugalbandi and an exploration of the navarasas — 
                        a celebration of rhythm, expression, and artistic joy.
                      </p>
                    </div>
                  </div>
                </section>
      
                {/* <section className="cultural-section cultural-grid">
                  <div className="cultural-block">
                    <h3>Highlights of the Evening</h3>
                    <ul>
                      <li>Classical dance performances (Bharatanatyam, Kathak, Odissi)</li>
                      <li>Folk dances from Punjab, Gujarat, Rajasthan, and North-East</li>
                      <li>Live musical performances with classical and fusion bands</li>
                      <li>Traditional costume walk showcasing regional attire</li>
                      <li>Food stalls offering regional delicacies</li>
                    </ul>
                  </div>
      
                  <div className="cultural-block">
                    <h3>Event Details</h3>
                    <p><strong>Date:</strong> 10th December 2025</p>
                    <p><strong>Time:</strong> 6:15 PM onwards</p>
                    <p><strong>Venue:</strong> J.N. Tata Auditorium, IISc Bengaluru</p>
      
                    <p className="cultural-note">
                      All participants, delegates, volunteers and guests are cordially invited to join us
                      and make the evening memorable.
                    </p>
                  </div>
                </section> */}
              </main>
      
              <Footer />
            </div>
          </>
        );
      };
    

export default CulturalProgram;

